import { createFileRoute, useNavigate } from "@tanstack/react-router";
import SetPassword from "@/components/singin/SetPassword";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { firebaseAuth } from "@/providers/authProvider";
import { z } from "zod";

export const Route = createFileRoute("/_layout/set-password")({
  validateSearch: z.object({
    mode: z.string().optional().catch(""),
    oobCode: z.string().optional().catch(""),
  }),
  component: SetPasswordComponent,
});

function SetPasswordComponent() {
  const navigate = useNavigate();
  // Route のクエリパラメータを reactive に取得（search の変化に追従させる）
  const { mode, oobCode } = Route.useSearch();

  const registPassword = async (
    password: string
  ): Promise<string | undefined> => {
    if (!oobCode) {
      return "リンクが無効です。メールに記載されたリンクから再度アクセスしてください。";
    }
    try {
      await verifyPasswordResetCode(firebaseAuth, oobCode);
      await confirmPasswordReset(firebaseAuth, oobCode, password);
    } catch (error) {
      console.error("Password reset error:", error);
      return "パスワード設定でエラーが発生しました。リンクが無効、または有効期限が切れている可能性があります。";
    }
    toast.success("パスワードを変更しました。", {
      position: "bottom-left",
    });
    navigate({ to: "/signin" });
    return;
  };

  useEffect(() => {
    if (!oobCode || mode !== "resetPassword") {
      navigate({ to: "/signin" });
    }
  }, [navigate, oobCode, mode]);

  return <SetPassword updatePassword={registPassword} />;
}
